import { getAccessToken, getRefreshToken } from '@/utils/cookieHelpers';
import { useAlertStore } from '@/stores/alertStore';
import { useAuthStore } from '@/stores/authStore';
import type { Router } from 'vue-router';
import { t } from '@/plugins/i18n';
import type { UserClaim } from '@/constants/userClaim';
import { RouteName } from './constants/routeNames';
import type { RouteRedirection } from './types';

export function registerAuthGuard(router: Router) {
  router.beforeEach((to, from, next) => {
    const appTitle = t('serviceShortName');

    const title = typeof to.meta?.title === 'string' ? to.meta.title : '';
    document.title = title ? `${title} | ${appTitle}` : appTitle;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      const { authState, checkClaims, onLogout } = useAuthStore();
      const accessToken = getAccessToken();
      const refreshToken = getRefreshToken();
      if (!accessToken || !refreshToken || !authState.isAuth) {
        onLogout();
        const redirection: RouteRedirection = {
          name: to.name as string,
          fullPath: to.fullPath,
          query: to.query as Record<string, string>,
          params: to.params as Record<string, string>
        };
        const base64RouteRedirection = btoa(JSON.stringify(redirection));
        next({
          name: RouteName.Home,
          query: { redirect: base64RouteRedirection }
        });
        return;
      }
      if ((to.meta.claims as string[])?.length) {
        const hasClaim = checkClaims(to.meta.claims as UserClaim[], authState.user.claims);
        if (!hasClaim) {
          const { addErrorAlert } = useAlertStore();
          addErrorAlert('apiStatusCodes.403');
          next({
            name: from.name || RouteName.Dashboard,
            query: from.query,
            params: from.params
          });
          return;
        }
      }
      next();
    } else {
      next();
    }
  });
}
